import { render, staticRenderFns } from "./CategoryHeading.vue?vue&type=template&id=3869f166&"
import script from "./CategoryHeading.vue?vue&type=script&lang=js&"
export * from "./CategoryHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports